// extracted by mini-css-extract-plugin
export default {"wrapper":"WithDrawal_wrapper__mixxL","item":"WithDrawal_item__0P8hM"};